/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { View } from 'react-native';
import { isWeb } from '@global/screens';
import { convertFullAddress, currency, parseDate } from '@global/helpers';
import Colors from '@global/colors';
import ItemDetail from '@components/global/ItemDetail';
import StatusBadge from '@components/global/StatusBadge';

// eslint-disable-next-line react/prop-types
const TargetSalesOrder = ({ detailSalesOrder = {} }) => {
  return (
    <View style={{ width: '100%' }}>
      <View
        style={{
          width: isWeb ? '45%' : '100%',
          paddingHorizontal: 20,
          paddingBottom: 20,
        }}>
        <ItemDetail
          name="Order Number"
          value={
            detailSalesOrder.reference_code
              ? detailSalesOrder.reference_code
              : '-'
          }
        />
        <ItemDetail
          name="Status"
          value={<StatusBadge status={detailSalesOrder.status} />}
        />
      </View>
      <View
        style={{
          width: '100%',
          padding: 20,
          borderTopColor: Colors.grey0,
          borderTopWidth: 1,
          flexDirection: isWeb ? 'row' : 'column',
          justifyContent: 'space-between',
        }}>
        <View style={{ width: isWeb ? '48%' : '100%' }}>
          <ItemDetail
            name="Customer"
            value={
              detailSalesOrder.customer && detailSalesOrder.customer.name
                ? detailSalesOrder.customer.name
                : '-'
            }
          />
          <ItemDetail
            name="Invoice Address"
            value={
              detailSalesOrder.invoice_address
                ? convertFullAddress(detailSalesOrder.invoice_address)
                : '-'
            }
          />
          <ItemDetail
            name="Delivery Address"
            value={
              detailSalesOrder.delivery_address
                ? convertFullAddress(detailSalesOrder.delivery_address)
                : '-'
            }
          />
          <ItemDetail
            name="Address"
            value={detailSalesOrder.street ? detailSalesOrder.street : '-'}
          />
          <ItemDetail
            name="Amount to Invoice"
            value={currency(detailSalesOrder.total_amount, true)}
          />
          <ItemDetail
            name="Open Receiveable"
            value={
              detailSalesOrder.open_receiveable
                ? detailSalesOrder.open_receiveable
                : '-'
            }
          />
          <ItemDetail
            name="Overdue Receiveable"
            value={
              detailSalesOrder.overdue_receiveable
                ? detailSalesOrder.overdue_receiveable
                : '-'
            }
          />
          <ItemDetail
            name="Remaining Credit"
            value={
              detailSalesOrder.remaining_credit
                ? detailSalesOrder.remaining_credit
                : '-'
            }
          />
          <ItemDetail
            name="Order date"
            value={
              detailSalesOrder.order_date
                ? parseDate(detailSalesOrder.order_date, 'd MMM yyyy HH:mm:ii')
                : '-'
            }
          />
        </View>
        <View style={{ width: isWeb ? '48%' : '100%' }}>
          <ItemDetail name="Pricelist" value="Pricelist Others (IDR)" />
          <ItemDetail
            name="Payment terms"
            value={
              detailSalesOrder.payment_terms
                ? detailSalesOrder.payment_terms
                : '-'
            }
          />
          <ItemDetail
            name="Sales Person"
            value={
              detailSalesOrder.sales_person &&
              detailSalesOrder.sales_person.name
                ? detailSalesOrder.sales_person.name
                : '-'
            }
          />
          <ItemDetail
            name="Sales Team"
            value={
              detailSalesOrder.sales_team && detailSalesOrder.sales_team.name
                ? detailSalesOrder.sales_team.name
                : '-'
            }
          />
          <ItemDetail
            name="Business Unit"
            value={
              detailSalesOrder.business_unit &&
              detailSalesOrder.business_unit.code
                ? detailSalesOrder.business_unit.code
                : '-'
            }
          />
          <ItemDetail
            name="Distribution Fee"
            value={
              detailSalesOrder.distribution_fee
                ? detailSalesOrder.distribution_fee
                : '-'
            }
          />
          <ItemDetail
            name="Amount of Refund"
            value={
              detailSalesOrder.amount_of_refund
                ? detailSalesOrder.amount_of_refund
                : '-'
            }
          />
          <ItemDetail
            name="Count of Refund"
            value={
              detailSalesOrder.count_of_refund
                ? detailSalesOrder.count_of_refund
                : '-'
            }
          />
        </View>
      </View>
    </View>
  );
};

export default TargetSalesOrder;
